/* The first-time introduction to voice feedback (APP-104 §3.2a). Tokens only; the look follows
   ConfirmDialog and the "Send feedback" dialog. */

.overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: grid;
  place-items: center;
  padding: 16px;
  background: var(--scrim);
}

.overlay[data-entering] {
  animation: fade var(--dur-fast) ease-out;
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .overlay[data-entering] {
    animation: none;
  }
}

.modal {
  width: min(520px, 100%);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  border-radius: var(--radius-md);
  background: var(--white);
  box-shadow: var(--shadow-dialog);
}

.modal::before {
  content: '';
  display: block;
  height: 4px;
  background: var(--gradient-rule);
}

.dialog {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px 28px 28px;
  outline: none;
}

.head {
  display: flex;
  align-items: center;
  gap: 14px;
}

.badge {
  display: grid;
  flex: none;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--brand-cyan-50);
  color: var(--brand-petrol);
}

.title {
  margin: 0;
  color: var(--text-heading);
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.02em;
}

.lead {
  margin: 0;
  color: var(--text-heading);
  font-size: 16px;
  line-height: 1.5;
}

.points {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.point {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  color: var(--text-heading);
  font-size: 15px;
  line-height: 1.5;
}

/* Centred on the first line of its words. */
.pointIcon {
  margin-top: 3px;
  color: var(--brand-petrol);
}

.note {
  margin: 0;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  background: var(--surface-soft);
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}
